<app-cards-basic title="{{ 'CATEGORIES.title' | translate:{ count: 1 } }}"
                 [loading]="isLoading">
  <mat-form-field class="w-100">
    <mat-label>{{ 'PERIODS.assign' | translate }}</mat-label>
    <input type="text"
           placeholder="{{ 'PERIODS.period_search' | translate }}"
           aria-label="Period"
           matInput
           [formControl]="periodControl"
           [matAutocomplete]="auto"
           #trigger="matAutocompleteTrigger" (focus)="trigger.openPanel()">
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignProduct($event.option.value)">
      <mat-option *ngFor="let product of filteredProducts | async" [value]="product">
        {{ product.translations['en'].title }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  @if (categoryData?.products?.length) {
    <div cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" class="w-100">
      <mat-chip-set aria-label="Product selection">
        @for (product of categoryData.products; track product) {
          <mat-chip-row cdkDrag (removed)="unassignProduct(product)">
            {{ product.product?.translations['en'].title }}
            <button matChipRemove [attr.aria-label]="'remove ' + product.product?.translations['en'].title">
              <mat-icon>
                <span class="material-symbols-outlined" (click)="unassignProduct(product)">close</span>
              </mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-set>
    </div>
  }
</app-cards-basic>

